import { wealthProApi } from '../../redux/api';
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const searchApiEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        searchMasterAccounts: builder.query({
            query: ({ searchTerm, page, limit, ...filters }) => ({
                url: `api/clientsearch/master-accounts/search`,
                method: 'POST',
                body: {
                    searchTerm,
                    page,
                    limit,
                    ...filters
                }
            }),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
        }),
        searchMasterAccountsList: builder.query({
            query: ({ searchTerm, page, limit }) => ({
                url: `api/clientsearch/master-accounts/search/list`,
                method: 'POST',
                body: {
                    searchTerm,
                    page,
                    limit
                }
            }),
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },
            merge: (currentCache, newItems) => {
                const { pagination: currPage } = currentCache || {};
                const { pagination: nextPage } = newItems || {};

                if (!currPage || nextPage.page <= currPage.page) {
                    return newItems;
                }

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results)
            },
            forceRefetch({ currentArg, previousArg }) {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            },
        })
    })
});

export const {
    useLazySearchMasterAccountsQuery,
    useLazySearchMasterAccountsListQuery,
    useSearchMasterAccountsQuery,
    useSearchMasterAccountsListQuery
} = searchApiEndpoints;

/*
serializeQueryArgs: ({ endpointName }) => {
    return endpointName
},
merge: (currentCache, newItems) => {
    const { pagination: currPage } = currentCache || {};
    const { pagination: nextPage } = newItems || {};

    if (!currPage || nextPage.page <= currPage.page) {
        return newItems;
    }

    currentCache.pagination = newItems.pagination;
    currentCache.results.push(...newItems.results)
},
forceRefetch({ currentArg, previousArg }) {
    const { page: currPage } = currentArg || { page: 1 };
    const { page: prevPage } = previousArg || { page: 0 };
    return currPage !== prevPage;
},
*/